import { forwardRef } from 'react'

interface CountProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
}

export const Count = forwardRef<HTMLSpanElement, CountProps>(
  ({ children, ...props }, forwardedRef) => {
    return (
      <span
        {...props}
        className='h-4 min-w-4 px-1 rounded-full inline-flex items-center justify-center caption font-medium bg-gray-500 text-white'
        ref={forwardedRef}
      >
        {children}
      </span>
    )
  }
)

Count.displayName = 'Tabs.Count'
